import { gql } from '@apollo/client';

export const PRICING_OVERRIDE_FIELDS = gql`
    fragment PricingOverrideFields on pricing_overrides {
        add_fuel_surcharge
        add_margin_flat
        add_margin_rate
        algo_type
        assign_id
        assign_partner
        client_id
        enabled
        marketplace_tier
        oms
        override_type
        partner_client_id
        pricing_override_id
        pricing_parameters
        tariff_id
        zip_geofence
        fuel_type
    }
`;
